export default function Footer() {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg text-background-50">天美影视</span>
            </div>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed mb-4">
              天美影视高清免费在线观看平台，不缓冲不卡顿流畅追剧，免费看最新高清电影电视剧全集，在线观看高清影视大全。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => scrollTo(e, '#hero')} className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-foreground-400 hover:text-background-50 text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => scrollTo(e, '#hero')} className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-foreground-400 hover:text-background-50 text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => scrollTo(e, '#hero')} className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-foreground-400 hover:text-background-50 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50 mb-4">快速导航</h3>
            <div className="space-y-2.5">
              <a href="#hero" onClick={(e) => scrollTo(e, '#hero')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#carousel" onClick={(e) => scrollTo(e, '#carousel')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a>
              <a href="#cards" onClick={(e) => scrollTo(e, '#cards')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热门推荐</a>
              <a href="#index" onClick={(e) => scrollTo(e, '#index')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">分类索引</a>
              <a href="#ranking" onClick={(e) => scrollTo(e, '#ranking')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热门榜单</a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50 mb-4">帮助中心</h3>
            <div className="space-y-2.5">
              <a href="#faq" onClick={(e) => scrollTo(e, '#faq')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#about" onClick={(e) => scrollTo(e, '#about')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于天美</a>
              <a href="#contact" onClick={(e) => scrollTo(e, '#contact')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#updates" onClick={(e) => scrollTo(e, '#updates')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a>
              <a href="#app" onClick={(e) => scrollTo(e, '#app')} className="block text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">移动观影</a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-50 mb-4">合作伙伴</h3>
            <div className="space-y-2.5">
              <div className="text-xs md:text-sm text-foreground-500">更多合作伙伴即将入驻</div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 天美影视 · 高清免费在线观看平台 · 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">用户协议</span>
            <span className="text-xs text-foreground-500">隐私政策</span>
            <span className="text-xs text-foreground-500">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}